<script setup lang="ts">
import { useDeviceState } from "@/stores/DeviceState";
import OfflineView from "./OfflineView.vue";

withDefaults(
  defineProps<{
    containerClasses?: string;
  }>(),
  {
    containerClasses: "my-5 mx-3 mx-md-4 mx-lg-5 px-sm-2 px-md-4 px-lg-5",
  }
);
const device = useDeviceState();
</script>

<template>
  <div :class="containerClasses">
    <OfflineView v-if="!device.isOnline" />
    <slot v-else></slot>
  </div>
</template>

<style lang="css" scoped></style>
